<template>
  <div class="burger-btn" :class="{ open: value }" @click="$emit('input', !value)">
    <div class="burger-btn__line" />
    <div class="burger-btn__line" />
    <div class="burger-btn__line" />
  </div>
</template>

<script>
import "./style.sass"

export default {
  name: "burger-btn",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/templates/components/ui-components/burger-btn/index.vue